import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Input } from '../input/input.component';
import { TabSmall } from '../tabs';

import { ContainerProps, SingleFilterContainerProps, FilterTitleProps } from './filters.types';

export const Wrapper: StyledComponent<'div'> = styled.div``;

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  position: fixed;
  right: 0;
  top: 0;
  max-width: 460px;
  width: 100%;
  max-height: calc(100% - 40px);
  height: 100%;
  margin: 20px;
  background-color: ${Color.White};
  transition: 0.3s;
  z-index: ${ZIndex.Filters};
  opacity: ${({ $isVisible }: ContainerProps): string => $isVisible ? '1' : '0'};
  pointer-events: ${({ $isVisible }: ContainerProps): string => $isVisible ? 'initial' : 'none'};

  @media ${Breakpoint.SmallMobile} {
    max-width: 100%;
    max-height: 100%;
    margin: 0;
  }
`;

export const FiltersContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: calc(100% - 62px);
  overflow: auto;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const FullFilterContainer: StyledComponent<'div'> = styled.div``;

export const SingleFilterContainer: StyledComponent<'div', SingleFilterContainerProps> = styled.div<SingleFilterContainerProps>`
  width: 100%;
  min-height: 58px;
  padding: 0 20px;
  border-bottom: ${({ $isSelected }: SingleFilterContainerProps): string => $isSelected ? 'none' : `1px solid ${Color.Gray300}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const FilterTitle: StyledComponent<'div', FilterTitleProps> = styled.div<FilterTitleProps>`
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  color: ${({ $isSelected }: FilterTitleProps): Color => $isSelected ? Color.Black : Color.Gray500};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
`;

export const IconContainer: StyledComponent<'button'> = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StyledInput: StyledComponent<typeof Input> = styled(Input)`
  max-width: 180px; 

  & + & {
    margin-left: 12px;
  }
`;

export const InputsContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  border-bottom: 1px solid ${Color.Gray300};
`;

export const OptionsContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid ${Color.Gray300};
`;

export const StyledTabSmall: StyledComponent<typeof TabSmall> = styled(TabSmall)`
  flex-shrink: 0;
  margin-right: 8px;
  margin-bottom: 12px;
`;

export const ButtonsContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 62px;
  position: absolute;
  bottom: 0;
  padding: 0 20px;
  border-top: 1px solid ${Color.Gray300};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledButton: StyledComponent<'button'> = styled.button`
  color: ${Color.Black};
  font-weight: ${FontWeight.Medium};
`;

export const StyledButtonClearFilters: StyledComponent<'button'> = styled.button`
  color: ${Color.Gray500};
  font-weight: ${FontWeight.Light};
  font-size: 16px;
`;

export const AutosuggestContainer: StyledComponent<'div'> = styled.div`
  padding: 20px;
`;
